export default async function uploadImage(image: File, imageId: string) {
    if (!image) {
        return imageId;
    }

    if (imageId) {
        await fetch(`${process.env.NEXT_PUBLIC_API_URL}/media/${imageId}`, {
            method: "DELETE", 
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    const formData = new FormData();

    formData.append("file", image[0].file);

    try {
        const imageReq = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/media`, {
            method: "POST", 
            credentials: "include",
            body: formData,
        });
        const imageData = await imageReq.json();
        if (imageData.errors) {
            return imageData;
        }
        return imageData.doc.id;
    } catch (err) {
        return { errors: [err] };
    }
}